import { Text } from 'foundations-components/components/Text';
import SanitizedText from 'sanitize-text/components/SanitizedText';
import { useCollectionQuery } from '../../search-results/hooks/useCollectionQuery';
import { useSearchResultsPageMetadata } from '../../search-results/hooks/useSearchResultsPageMetadata';
import { UnifiedHeader } from './UnifiedHeader';
import { jsx as _jsx } from "react/jsx-runtime";
export function SearchResultsPageHeader() {
  var _collectionResult$dat, _collectionResult$dat2;
  const collectionResult = useCollectionQuery();
  const isCollection = !!collectionResult.data;
  const {
    heading
  } = useSearchResultsPageMetadata();
  const collectionDescription = collectionResult.isUmbrellaCollection ? (_collectionResult$dat = collectionResult.data) === null || _collectionResult$dat === void 0 ? void 0 : _collectionResult$dat.description : (_collectionResult$dat2 = collectionResult.data) === null || _collectionResult$dat2 === void 0 || (_collectionResult$dat2 = _collectionResult$dat2.publishedListing) === null || _collectionResult$dat2 === void 0 ? void 0 : _collectionResult$dat2.description;
  return /*#__PURE__*/_jsx(UnifiedHeader, {
    dataTestId: "search-page-header",
    backBreadcrumb: !isCollection,
    title: heading,
    subtitle: collectionDescription ? /*#__PURE__*/_jsx(Text, {
      color: "text-core-subtle",
      typography: "body-100",
      children: /*#__PURE__*/_jsx(SanitizedText, {
        body: collectionDescription,
        WrapperComponent: "span"
      })
    }) : undefined,
    pathKey: isCollection ? 'FEATURED_COLLECTION' : 'SEARCH_RESULTS'
  });
}